export const FETCH_INGREDIENTS = {
  START: 'START_FETCH_INGREDIENTS',
  COMPLETE: 'COMPLETE_FETCH_INGREDIENTS',
  FAIL: 'FAIL_FETCH_INGREDIENTS',
  CLEANUP: 'CLEANUP_FETCH_INGREDIENTS',
}

export const ADD_INGREDIENT = 'ADD_INGREDIENT'
export const RENAME_INGREDIENT = 'RENAME_INGREDIENT'
export const RESET_INGREDIENT_TREE = 'RESET_INGREDIENT_TREE'

export const SET_DATA_FOR_RENAMING_INGREDIENT =
  'SET_DATA_FOR_RENAMING_INGREDIENT'

export const SET_IS_CURATION_ENABLED_INGREDIENT = {
  START: 'START_SET_IS_CURATION_ENABLED_INGREDIENT',
  COMPLETE: 'COMPLETE_SET_IS_CURATION_ENABLED_INGREDIENT',
  FAIL: 'FAIL_SET_IS_CURATION_ENABLED_INGREDIENT',
}

export const DELETE_INGREDIENT = {
  START: 'START_DELETE_INGREDIENT',
  COMPLETE: 'COMPLETE_DELETE_INGREDIENT',
  FAIL: 'FAIL_DELETE_INGREDIENT',
}

export const REPLACE_INGREDIENT = {
  START: 'START_REPLACE_INGREDIENT',
  COMPLETE: 'COMPLETE_REPLACE_INGREDIENT',
  FAIL: 'FAIL_REPLACE_INGREDIENT',
}

export const REVERT_REPLACE_INGREDIENT = {
  START: 'START_REVERT_REPLACE_INGREDIENT',
  COMPLETE: 'COMPLETE_REVERT_REPLACE_INGREDIENT',
  FAIL: 'FAIL_REVERT_REPLACE_INGREDIENT',
}

export const MOVE_INGREDIENTS = 'MOVE_INGREDIENTS'

export const SAVE_INGREDIENTS = {
  START: 'START_SAVE_INGREDIENTS',
  COMPLETE: 'COMPLETE_SAVE_INGREDIENTS',
  FAIL: 'FAIL_SAVE_INGREDIENTS',
}

export const EXPAND_INGREDIENT_MAIN_TREE_KEYS =
  'EXPAND_INGREDIENT_MAIN_TREE_KEYS'

export const EXPAND_INGREDIENT_SUPPORTING_TREE_KEYS =
  'EXPAND_INGREDIENT_SUPPORTING_TREE_KEYS'
